/**
 * SpotGo Configuration Constants
 */

export const SPOT_CONSTANTS = {
    // Radar Scan & Map
    SCAN_THRESHOLD_M: 2000,
    RADAR_STEPS: [1000, 5000, 10000, 50000],

    // Registration Limits
    MAX_PHOTOS: {
        STORE: 5,
        FOOTPRINT: 3
    },

    // Post Cooldown (seconds)
    POST_COOLDOWN: 60,

    // Map View Settings
    KOREA_BOUNDS: {
        LAT_MIN: 33,
        LAT_MAX: 39,
        LNG_MIN: 124,
        LNG_MAX: 132
    },

    // Premium Radius (50km Paid Feature)
    PREMIUM_RADIUS: {
        VALUE: 50000, // 50km in meters
        COST: 100, // STAR
        DURATION: 24 * 60 * 60 * 1000, // 24 hours in ms
        DEFAULT_RADIUS: 10000 // 10km default
    },

    // Modal Gesture
    SWIPE_THRESHOLD: 40,
};

export default SPOT_CONSTANTS;
